// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var NumberSequenceListController = function ($scope, NumberSequence, gettext, gettextCatalog) {
    $scope.sequences = NumberSequence.query({ });

    $scope.deleteNumberSequence = function (sequenceId) {
        $scope.yesCancel(gettextCatalog.getString(gettext("Delete Sequence")), gettextCatalog.getString(gettext("Are you sure?")), function () { NumberSequence.remove({ sequenceId: sequenceId }, function () { $scope.sequences = NumberSequence.query(); }); });
    };
};
NumberSequenceListController.$inject = ['$scope', 'NumberSequence', 'gettext', 'gettextCatalog'];
